import { Autocomplete, Button, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { RateCardPreview } from "./rate-card-preview"
import { RateCardAutocompleteInput } from "./rate-card-autocomplete-input"
import { RateCardAutocompleteOption } from "./rate-card-autocomplete-option"
import { RateCardAutocompleteTags } from "./rate-card-autocomplete-tags"
import { useCreateRateCard } from "../rate-cards/use-create-rate-card"

export function RateCardSection({
    rateCardItems,
    selectedRateCard,
    selectedRegime,
    onSelect,
    expanded,
    onToggleExpand,
}) {
    const handleCreateRateCard = useCreateRateCard({ navigateOnCreate: false, regimeId: selectedRegime?.id })

    return (
        <Stack spacing={1.5}>
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Iconify icon="solar:user-id-broken" width={20} height={20} sx={{ color: "common.black" }} />
                    <Typography variant="subtitle1" fontWeight={600}>
                        Rate Card
                    </Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                    Rate cards use your skill mappings to price each trade
                </Typography>
            </Stack>
            <Autocomplete
                data-cy="rate-card-selector"
                options={rateCardItems}
                value={selectedRateCard}
                onChange={handleChange}
                getOptionLabel={getRateCardLabel}
                isOptionEqualToValue={isRateCardEqual}
                renderInput={RateCardAutocompleteInput}
                renderOption={RateCardAutocompleteOption}
                renderTags={RateCardAutocompleteTags}
                noOptionsText={renderEmptyState()}
                fullWidth
            />
            <If value={selectedRateCard}>
                <RateCardPreview rateCard={selectedRateCard} expanded={expanded} onToggleExpand={onToggleExpand} />
            </If>
        </Stack>
    )

    function handleChange(__, value) {
        onSelect(value)
    }

    function renderEmptyState() {
        return (
            <Stack alignItems="center" spacing={1} sx={{ py: 2 }}>
                <Typography variant="body1" sx={{ color: "text.primary" }}>
                    No rate cards added yet
                </Typography>
                <Button
                    data-cy="dropdown-add-rate-card"
                    variant="text"
                    color="primary"
                    startIcon={<Iconify icon="mdi:plus" />}
                    onMouseDown={handleAddRateCard}
                    sx={{ fontWeight: 600 }}
                >
                    Add Rate Card
                </Button>
            </Stack>
        )
    }

    function handleAddRateCard(event) {
        event.preventDefault()
        event.stopPropagation()
        createAndSelectRateCard()
    }

    async function createAndSelectRateCard() {
        const created = await handleCreateRateCard()
        if (!created?.id) return
        onSelect(created)
    }
}

function getRateCardLabel(card) {
    return card?.name ?? ""
}

function isRateCardEqual(option, value) {
    return option?.id === value?.id
}
